"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUND = void 0;
exports.ROUND = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: () => {
        throw new Error('Function:ROUND not implemented');
    },
};
//# sourceMappingURL=round.js.map